import Aos from "aos";
import 'magnific-popup';
import 'slick-carousel';

jQuery( document ).ready(function($) {
    $('.search-toggle').on('click', function(e){
        $('.search-wrapper').toggleClass('open');
        $('.menu-wrapper').removeClass('open');
    })
    $('.menu-toggle').on('click', function(e){
        $('.menu-wrapper').toggleClass('open');
        $('.search-wrapper').removeClass('open');
    })

    // SOCIAL WIDGET TABS
    $('.social-widget .tab').on('click', function (e) { 
        e.preventDefault();
        $('.social-widget .tab, .social-widget .view').removeClass('active');
        $(this).addClass('active');
        const viewId = $(this).attr('href');
        $(viewId).addClass('active');
    });

    $(document).on('click', '.p45-tab-button', function(e) {
        e.preventDefault();

        // 1. Define the scope (the specific tab block we clicked in)
        var $button = $(this);
        var $wrapper = $button.closest('.p45-tabs-wrapper');
        var index = $button.index();

        // 2. Toggle Buttons
        $wrapper.find('.p45-tab-button').removeClass('active');
        $button.addClass('active');

        // 3. Toggle Panes based on index
        $wrapper.find('.p45-tab-pane').removeClass('is-active');
        $wrapper.find('.p45-tab-pane').eq(index).addClass('is-active');
    });

    $('.carousel').slick({
        slidesToShow: 1,
        variableWidth: false, 
        centerMode: true,
        centerPadding: '400px', // default padding for wider screens
        initialSlide: 0,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="fal fa-circle-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="fal fa-circle-chevron-right"></i></button>',
        dots: false,
        customPaging: function (slider, i) {
            return '<button type="button" aria-label="Slide ' + (i + 1) + '"></button>';
        },
        responsive: [{
            breakpoint: 1600, 
            settings: {
                centerPadding: '350px'
            }
        },{
            breakpoint: 1500, 
            settings: {
                centerPadding: '250px'
            }
        },{
            breakpoint: 1200,
            settings: {
                centerPadding: '150px'
            }
        },{
            breakpoint: 1000,
            settings: {
                centerPadding: '50px'
            }
        },{
            breakpoint: 500,
            settings: {
                centerPadding: '20px'
            }
        }]
    });

    
    $("#main").on('click', '.img-lightbox', function (e) {
        e.preventDefault();

        $.magnificPopup.open({
            items: {
                src: $(this).attr('href')
            },
            type: 'image',
            closeOnContentClick: true,
            image: {
                verticalFit: true
            }
        });
    });

    Aos.init();

    const $heroCta = $('.block-p45_video_hero .cta');
    if ($heroCta.length) {
        $(window).on('scroll.heroCta', function () {
            $heroCta.toggleClass('hidden', $(window).scrollTop() > 0);
        });
    }
});